var redirectToMaintenance = function () {
    if (process.client && window.location.pathname !== '/maintenance') {
        window.location.replace('/maintenance');
    }
};
export default redirectToMaintenance;
